import type { QueryClient, QueryKey } from "@tanstack/react-query";
import dayjs, { ISO_DATE_FORMAT } from "../dayjs";
import type { SavedOrder } from "./orderTypes";

export async function invalidateOnOrderChange(queryClient: QueryClient, order: Pick<SavedOrder, "id" | "start">) {
  const year = dayjs(order.start, ISO_DATE_FORMAT).format("YYYY");
  await queryClient.invalidateQueries({
    predicate: (q) => isYearOrSpecificIdQuery(q.queryKey, order.id, year),
  });
}

function isYearOrSpecificIdQuery(queryKey: QueryKey, orderId: string, year: string): boolean {
  if (queryKey[0] !== "orders") {
    return false;
  }
  if (queryKey[1] === orderId) {
    return true;
  }
  if (typeof queryKey[1] === "object" && (queryKey[1] as { year?: string })?.year === year) {
    return true;
  }
  return false;
}
